import React from 'react';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import Coach from './Coach';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle} from '@fortawesome/free-regular-svg-icons';

// This is the query that Apollo Client will send to the WP site.
const COACHES_QUERY = gql`
query MyQuery {
  coaches {
    edges {
      node {
        title
        coach_information {
          jobInformation {
            company
            companyUrl
            title
          }
          links {
            instagramHandle
            portfolioUrl
            twitterHandle
          }
          nameInformation {
            first
            last
          }
        }
        featuredImage {
          altText
        sourceUrl(size: MEDIUM)
        }
      }
    }
  }
}
`;

const CoachList = () => {
	const { loading, error, data } = useQuery(COACHES_QUERY);

	if (loading) return 'Loading...';
	if (error) return `Error! ${error.message}`;

	return (<section className="region coaches" id="who">
		<h2><FontAwesomeIcon icon={faUserCircle} /> Coaches</h2>
			<div className="container">
				<div className="coach-grid">
					{data.coaches.edges.map((edge,key) => {
						return <Coach key={key} edge={edge} />
					})}
				</div>
			</div>
	</section>)
};

export default CoachList;
